// extracted by mini-css-extract-plugin
export var fadeIn = "_jj-1";
export var modalContent = "_jj-3";
export var overlay = "_jj-0";
export var popoverContent = "_jj-2";
export var results = "_jj-5";
export var searchInputWrapper = "_jj-4";